export const CATEGORY_ICONS = {
  times: 'fad fa-calendar-days',
  duration: 'fad fa-clock',
  meeting_point: 'fad fa-map-location-dot',
  cancellation_rebook: 'fad fa-circle-xmark',
  languages: 'fad fa-globe',
  further_information: 'fad fa-circle-info',
  tickets: 'fad fa-ticket',
  inclusions: 'fad fa-check',
}
